// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.amenities.apartments.RentalManagerUserPropertyApartmentAmenityWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, UserPropertyApartmentAmenityCreateResponseWebDto } from '../..';

interface CreateParams {
  availableInSelectUnits?: boolean;
  listingAlias: ListingAlias;
  text: string;
}
interface DeleteParams {
  amenityId: string;
}

export const RentalManagerUserPropertyApartmentAmenityWebApiHandler_create_Path =
  '/api/web/v1/users/properties/amenities/apartments/create';

/**
 * Create a free text apartment amenity
 * @deprecated
 */
export const RentalManagerUserPropertyApartmentAmenityWebApiHandler_create = (
  getParams: CreateParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<CreateParams, never, UserPropertyApartmentAmenityCreateResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyApartmentAmenityWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyApartmentAmenityWebApiHandler_delete_Path =
  '/api/web/v1/users/properties/amenities/apartments/delete';

/**
 * Delete a free text apartment amenity
 * @deprecated
 */
export const RentalManagerUserPropertyApartmentAmenityWebApiHandler_delete = (
  getParams: DeleteParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DeleteParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyApartmentAmenityWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
